/* eslint-disable @typescript-eslint/no-explicit-any */
import { BaseCheckbox } from 'app/components/common/BaseCheckbox'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import { convertColumnTable } from 'app/components/tables/BaseTableReport/hook'
import { ITeam } from 'app/containers/EventManagement/layouts/CreateEvent/type'
import { useCheckInActionByMember } from 'app/react-query/hook/event'
import { useMemo } from 'react'
import { IActivityEvent } from '../../../UpdateTumInActionEvent/type'
import { PermissionEnum } from 'app/common/enum'
import { useVerifyPermission } from 'app/helpers/permission.helper'
import { ITradeUnionMember } from 'app/api/tradeUnionMembers/model'
import { TypeColumn } from 'app/api/event/model'
import { DateUtil, FORMAT_DD_MM_YYYY } from 'parkway-web-common'

interface IProps {
  activity: IActivityEvent
  index: number
  team: ITeam
}

export const ColumnTumActivityOfTeam = ({ activity, team }: IProps) => {
  const { mutateAsync: mutateAsyncCheckIn, isLoading } =
    useCheckInActionByMember()
  const data = useMemo(() => {
    return team?.tums?.map((item, index) => {
      return {
        ...item,
        key: item?.id,
        index: index + 1,
      }
    })
  }, [team?.tums])

  const handleCheckIn = async ({
    value,
    tumId,
  }: {
    value: boolean
    tumId?: string
  }) => {
    if (!activity?.id) return

    if (!tumId) return

    await mutateAsyncCheckIn({
      value: value,
      actionId: activity?.id,
      tumId: tumId,
    })
  }

  const { verifyPermission } = useVerifyPermission()

  const columnsWithoutMainColumn = useMemo(() => {
    return activity?.columns?.filter(itm => !itm?.keyOfMainData) ?? []
  }, [activity?.columns])

  return <BaseSpace style={{ display: 'flex', flex: 1, maxWidth: '100%' }}>
      <BaseTableManagement
        columns={[
          convertColumnTable<ITradeUnionMember>({
            key: 'fullName',
            title: 'Tên đoàn viên',
            render: (_: any, record?: ITradeUnionMember) => {
              return (
                <BaseText
                  children={record?.fullName ?? ''}
                  fontWeight="medium"
                  opacity={'1'}
                />
              )
            },
          }),
          convertColumnTable<ITradeUnionMember>({
            key: 'mql',
            title: 'Mã quản lý',
            render: (_: any, record?: ITradeUnionMember) => {
              return (
                <BaseText
                  children={record?.mql ?? ''}
                  fontWeight="medium"
                  opacity={'1'}
                />
              )
            },
          }),
          convertColumnTable<ITradeUnionMember>({
            key: 'gioiTinh',
            title: 'Giới tính',
            render: (_: any, record?: ITradeUnionMember) => {
              return (
                <BaseText
                  children={record?.gioiTinh ?? ''}
                  fontWeight="medium"
                  opacity={'1'}
                />
              )
            },
          }),
          ...((columnsWithoutMainColumn?.map(column => {
            return {
              title: column?.name,
              dataIndex: column?.name,
              key: column?.name,
              className: 'big-column',
              render: (_: any, record?: any) => {
                if (column?.type === TypeColumn.DATE) {
                  return (
                    <BaseText
                      children={record?.[column?.name ?? ''] ? DateUtil.formatDate(
                        record?.[column?.name ?? ''],
                        FORMAT_DD_MM_YYYY,
                      ) : ''}
                      fontWeight="medium"
                      opacity={'0.7'}
                    />
                  )
                }
                return (
                  <BaseText
                    children={record?.[column?.name ?? ''] ?? ''}
                    fontWeight="medium"
                    opacity={'0.7'}
                  />
                )
              },
            }
          }) ?? []) as any),
          ...(verifyPermission(PermissionEnum.UpdateEvent)
            ? [
                convertColumnTable<any>({
                  key: 'checkedIn',
                  title: 'Check in',
                  fixed: 'right',
                  render: (_, record) => {
                    return (
                      <BaseCheckbox
                        checked={record?.checkedIn}
                        value={record?.checkedIn}
                        onChange={e =>
                          handleCheckIn({
                            value: e?.target?.checked,
                            tumId: record?.key,
                          })
                        }
                      />
                    )
                  },
                }),
              ]
            : []),
        ]}
        dataSource={data}
        className="row-overwrite-style"
        scroll={{ x: true }}
        pagination={{
          defaultPageSize: 5,
          showSizeChanger: true,
        }}
        loading={isLoading}
      />
    </BaseSpace>
}
